/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAOs = /* GraphQL */ `
  query GetAOs($company: String!) {
    getAOs(company: $company) {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const getUsersByAO = /* GraphQL */ `
  query GetUsersByAO($aoNum: String!, $company: String!) {
    getUsersByAO(aoNum: $aoNum, company: $company) {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const getUserById = /* GraphQL */ `
  query GetUserById($id: ID!, $company: String!) {
    getUserById(id: $id, company: $company) {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const getUserByAgentNum = /* GraphQL */ `
  query GetUserByAgentNum($agentNum: String, $company: String!) {
    getUserByAgentNum(agentNum: $agentNum, company: $company) {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const getAgenciesByAONum = /* GraphQL */ `
  query GetAgenciesByAONum($aoNum: String!, $company: String!) {
    getAgenciesByAONum(aoNum: $aoNum, company: $company) {
      EntAgencyID
      AgencyCode
      AOAgentNumPrimary
      GLAgencyStatus
      AgencyName
      Email
      AgencyAddressID
      AddressLine1
      AddressLine2
      City
      StateProvinceCode
      PostalCode
      GLCountryID
      AgencyPhoneID
      AreaCode
      PhoneNum
      PhoneExtensionNum
      ISOCountryCode
      CountryName
      GLAddressTypeID
      GLCompanyID
      GLPhoneTypeID
      LastModified
      LastModifiedBy
      PrimaryAgencyInd
    }
  }
`;
export const getCountries = /* GraphQL */ `
  query GetCountries {
    getCountries {
      id
      code
      name
    }
  }
`;
export const getAOByUser = /* GraphQL */ `
  query GetAOByUser($agentNum: String!, $company: String!) {
    getAOByUser(agentNum: $agentNum, company: $company) {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const getNewIndicatorForAgentNum = /* GraphQL */ `
  query GetNewIndicatorForAgentNum($agentNum: String!, $days: String!) {
    getNewIndicatorForAgentNum(agentNum: $agentNum, days: $days)
  }
`;
export const getHierarchyRoles = /* GraphQL */ `
  query GetHierarchyRoles {
    getHierarchyRoles {
      roleId
      roleAbbr
    }
  }
`;
export const getLastModified = /* GraphQL */ `
  query GetLastModified($aoNum: String!) {
    getLastModified(aoNum: $aoNum)
  }
`;
export const getAgencyHistoryByAgencyCode = /* GraphQL */ `
  query GetAgencyHistoryByAgencyCode($agencyCode: String!, $company: String!) {
    getAgencyHistoryByAgencyCode(agencyCode: $agencyCode, company: $company) {
      EntAgencyID
      AgencyCode
      AOAgentNumPrimary
      GLAgencyStatus
      AgencyName
      Email
      AgencyAddressID
      AddressLine1
      AddressLine2
      City
      StateProvinceCode
      PostalCode
      GLCountryID
      AgencyPhoneID
      AreaCode
      PhoneNum
      PhoneExtensionNum
      ISOCountryCode
      CountryName
      GLAddressTypeID
      GLCompanyID
      GLPhoneTypeID
      LastModified
      LastModifiedBy
      PrimaryAgencyInd
    }
  }
`;
export const getAgencyHistoryByDateRange = /* GraphQL */ `
  query GetAgencyHistoryByDateRange(
    $rangeStart: String!
    $rangeEnd: String!
    $company: String!
  ) {
    getAgencyHistoryByDateRange(
      rangeStart: $rangeStart
      rangeEnd: $rangeEnd
      company: $company
    ) {
      EntAgencyID
      AgencyCode
      AOAgentNumPrimary
      GLAgencyStatus
      AgencyName
      Email
      AgencyAddressID
      AddressLine1
      AddressLine2
      City
      StateProvinceCode
      PostalCode
      GLCountryID
      AgencyPhoneID
      AreaCode
      PhoneNum
      PhoneExtensionNum
      ISOCountryCode
      CountryName
      GLAddressTypeID
      GLCompanyID
      GLPhoneTypeID
      LastModified
      LastModifiedBy
      PrimaryAgencyInd
    }
  }
`;
